module.exports = __webpack_public_path__ + "img/haibao5@2x_new.35d64e96.png";